import React, { useCallback } from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
import { triggerProductFilterClicked, useCreateFireAnalyticsFromTrigger } from '../../../common/utils/analytics';
import { selectedButtonStyle, unSelectedButtonStyle } from './styled';
export var ProductButton = function ProductButton(_ref) {
  var product = _ref.product,
    isSelected = _ref.isSelected,
    notificationFilters = _ref.notificationFilters;
  var intl = useIntl();
  var handleProductFiltersAnalytics = useCreateFireAnalyticsFromTrigger(triggerProductFilterClicked);
  var handleProductOnClick = useCallback(function (product) {
    notificationFilters.handleSetProductFilter(product);
    handleProductFiltersAnalytics(product);
  }, [notificationFilters, handleProductFiltersAnalytics]);
  return /*#__PURE__*/React.createElement(Button, {
    spacing: "compact"
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ,
    style: isSelected ? selectedButtonStyle : unSelectedButtonStyle,
    onClick: function onClick() {
      return handleProductOnClick(product.key);
    },
    testId: "product-filter-".concat(product.key)
  }, intl.formatMessage(product.label));
};